import { useState, useEffect } from "react";
import { useNavigate, Navigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import LogoMark from "@/components/LogoMark";
import { toast } from "sonner";

export default function AdminLogin() {
  const { user, checking, login } = useAuth();
  const nav = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (user && user.role === "admin") nav("/admin/dashboard", { replace: true });
  }, [user, nav]);

  async function submit(e) {
    e.preventDefault();
    setLoading(true);
    try {
      await login(email, password);
      toast.success("Welcome back.");
      nav("/admin/dashboard", { replace: true });
    } catch (err) {
      toast.error(err?.response?.data?.detail || "Invalid credentials");
    } finally {
      setLoading(false);
    }
  }

  if (checking) return null;
  if (user && user.role === "admin") return <Navigate to="/admin/dashboard" replace />;

  return (
    <section className="min-h-[80vh] py-24 flex items-center">
      <div className="max-w-[440px] w-full mx-auto px-6" data-testid="admin-login-page">
        <div className="flex items-center gap-3 mb-6">
          <LogoMark size={40} />
          <div>
            <div className="font-display text-xl leading-none">HOFA Admin</div>
            <div className="text-xs uppercase tracking-[0.14em] text-palm font-bold mt-1">Staff sign-in</div>
          </div>
        </div>
        <form onSubmit={submit} className="bg-white border border-ink/10 rounded-[14px] p-7">
          <label className="text-sm font-semibold block mb-1">Email</label>
          <input required type="email" value={email} onChange={(e) => setEmail(e.target.value)} data-testid="admin-email-input" className="w-full rounded-md border border-ink/15 px-3 py-2.5 mb-4 focus:outline-none focus:border-palm" />
          <label className="text-sm font-semibold block mb-1">Password</label>
          <input required type="password" value={password} onChange={(e) => setPassword(e.target.value)} data-testid="admin-password-input" className="w-full rounded-md border border-ink/15 px-3 py-2.5 mb-5 focus:outline-none focus:border-palm" />
          <button disabled={loading} data-testid="admin-login-btn" className="w-full bg-palm text-white font-bold rounded-full px-6 py-3 hover:shadow-xl hover:-translate-y-0.5 transition disabled:opacity-60">
            {loading ? "Signing in…" : "Sign in"}
          </button>
        </form>
        <p className="text-xs text-ink/55 mt-4 text-center">HOFA · Brewerville, Liberia</p>
      </div>
    </section>
  );
}
